export const calculateCokluZeka = (answers) => {
    // 1. Zeka türleri ve kapsadıkları soru numaraları (10'ar soru)
    const categories = [
        { id: "sozel", name: "Sözel-Dilsel Zeka", range: [1, 10] },
        { id: "mantiksal", name: "Mantıksal-Matematiksel Zeka", range: [11, 20] },
        { id: "gorsel", name: "Görsel-Uzamsal Zeka", range: [21, 30] },
        { id: "muziksel", name: "Müziksel-Ritmik Zeka", range: [31, 40] },
        { id: "bedensel", name: "Bedensel-Kinestetik Zeka", range: [41, 50] },
        { id: "dogaci", name: "Doğacı Zeka", range: [51, 60] },
        { id: "sosyal", name: "Sosyal (Kişiler Arası) Zeka", range: [61, 70] },
        { id: "icsel", name: "İçsel (Öze Dönük) Zeka", range: [71, 80] }
    ];

    const chartData = [];
    let grandTotalPoints = 0; // Toplam puan (Maks 320)
    
    // 2. Her bir kategori için puan hesaplama
    categories.forEach(cat => {
        let totalScore = 0;
        for (let i = cat.range[0]; i <= cat.range[1]; i++) {if (answers[i] !== undefined) {
    totalScore += (Number(answers[i]) || 0); // Sayı değilse direkt 0 kabul et ve sistemi koru
}
        }
        
        grandTotalPoints += totalScore;

        chartData.push({ 
            subject: cat.name, 
            A: totalScore, 
            fullMark: 40,
            percent: Math.round((totalScore / 40) * 100)
        });
    });

    // 3. Seviye Belirleme Fonksiyonu (ÖNCE SEVİYELERİ BUL)
   const getLevel = (score) => {
    if (score >= 32) return {
        label: "Çok Belirgin Eğilim",
        color: "text-violet-700",
        bg: "bg-violet-100",
        levelKey: "expert"
    };

    if (score >= 24) return {
        label: "Belirgin Eğilim",
        color: "text-indigo-700",
        bg: "bg-indigo-100",
        levelKey: "advanced"
    };

    if (score >= 16) return {
        label: "Orta Düzey Eğilim",
        color: "text-blue-700",
        bg: "bg-blue-100",
        levelKey: "intermediate"
    };

    if (score >= 8) return {
        label: "Daha Az Belirgin Eğilim",
        color: "text-slate-600",
        bg: "bg-slate-100",
        levelKey: "basic"
    };

    return {
        label: "Sınırlı Belirginlik",
        color: "text-slate-500",
        bg: "bg-slate-100",
        levelKey: "none"
    };
};

    const details = chartData.map(item => ({
        ...item,
        status: getLevel(item.A)
    }));

    // 4. Sıralama ve En Baskın Olanları Bulma (SONRA SIRALA)
    // 🚀 DİKKAT: chartData'yı değil, rozetleri taktığımız 'details' listesini sıralıyoruz!
    const sortedIntelligences = [...details].sort((a, b) => b.A - a.A);
    const top1 = sortedIntelligences[0];
    const top2 = sortedIntelligences[1];
    const top3 = sortedIntelligences.slice(0, 3);

   // 🚀 5. PROFİL METRİĞİ
// Bu değer IQ veya "genel zeka düzeyi" değildir.
// Sekiz alandaki yanıtların toplam ölçek maksimumuna göre
// genel yanıt yoğunluğunu teknik olarak ifade eder.
const developmentScore = Math.round((grandTotalPoints / 320) * 100);

// Çoklu Zeka bir risk/tarama testi değildir.
// Düşük veya yüksek profil puanından psikolojik risk çıkarımı yapılmaz.
const riskLevel = "none";

    const analysisText =
  `Çoklu Zeka Envanteri, öğrencinin farklı öğrenme, problem çözme ve kendini ifade etme alanlarındaki eğilim profilini göstermektedir; genel zeka (IQ) düzeyini ölçmez.\n\n` +
  `En belirgin alan: **${top1.subject}** (${top1.status.label}).\n` +
  `İkinci öne çıkan alan: **${top2.subject}** (${top2.status.label}).\n\n` +
  `Sonuçlar sabit bir yetenek sınırı olarak değil, öğrencinin öğrenmeye katılımını ve kendini ifade etmesini destekleyebilecek alanlara ilişkin ipuçları olarak değerlendirilmelidir.`;

// 🌟 ÖĞRENCİYE GÖSTERİLECEK KISA VE YAŞA UYGUN GERİ BİLDİRİM
const STUDENT_FEEDBACK_MAP = {

  "Sözel-Dilsel Zeka": {
    headline: "Sözel-Dilsel Alanın Öne Çıkıyor",
    message:
      "Kelimelerle düşünmek, okumak, yazmak, anlatmak ve düşüncelerini ifade etmek sana yakın öğrenme yolları arasında olabilir. Konuları kendi cümlelerinle özetlemek, sesli anlatmak ve notlar çıkarmak öğrenmeni destekleyebilir."
  },

  "Mantıksal-Matematiksel Zeka": {
    headline: "Mantıksal-Matematiksel Alanın Öne Çıkıyor",
    message:
      "Neden-sonuç ilişkileri kurmak, problemleri adım adım çözmek, örüntüleri fark etmek ve bilgileri sistemli biçimde incelemek sana yakın olabilir. Konuları tablolar, kurallar ve problem çözme çalışmalarıyla ele almak işini kolaylaştırabilir."
  },

  "Görsel-Uzamsal Zeka": {
    headline: "Görsel-Uzamsal Alanın Öne Çıkıyor",
    message:
      "Şekiller, görseller, renkler, grafikler ve zihninde canlandırabildiğin bilgiler öğrenirken sana yardımcı olabilir. Zihin haritaları, şemalar, çizimler ve görsel notlar kullanmayı deneyebilirsin."
  },

  "Müziksel-Ritmik Zeka": {
    headline: "Müziksel-Ritmik Alanın Öne Çıkıyor",
    message:
      "Ritimleri, sesleri ve işitsel örüntüleri fark etmek sana doğal gelebilir. Bilgileri ritmik tekrarlarla, sesli kalıplarla veya kendi hatırlama ritimlerini oluşturarak çalışmak öğrenmeni destekleyebilir."
  },

  "Bedensel-Kinestetik Zeka": {
    headline: "Bedensel-Kinestetik Alanın Öne Çıkıyor",
    message:
      "Bir şeyi yaparak, deneyerek, hareket ederek veya somutlaştırarak öğrenmek sana daha yakın olabilir. Deneyler, modeller, uygulamalı çalışmalar ve kısa hareket molaları öğrenme sürecini destekleyebilir."
  },

  "Doğacı Zeka": {
    headline: "Doğacı Alanın Öne Çıkıyor",
    message:
      "Çevrendeki canlıları, sistemleri, benzerlikleri ve farklılıkları fark etmek sana yakın olabilir. Bilgileri sınıflandırmak, gruplamak ve gerçek yaşam örnekleriyle ilişkilendirmek öğrenmeni kolaylaştırabilir."
  },

  "Sosyal (Kişiler Arası) Zeka": {
    headline: "Sosyal Alanın Öne Çıkıyor",
    message:
      "İnsanlarla iletişim kurmak, birlikte çalışmak, başkalarının bakış açılarını anlamak ve bildiklerini paylaşmak sana yakın olabilir. Bir konuyu arkadaşına anlatmak, tartışmak veya birlikte çalışmak öğrenmeni destekleyebilir."
  },

  "İçsel (Öze Dönük) Zeka": {
    headline: "İçsel Farkındalık Alanın Öne Çıkıyor",
    message:
      "Kendi düşüncelerini, hedeflerini ve duygularını fark ederek ilerlemek sana yakın olabilir. Bireysel çalışma planları oluşturmak, kendi hedeflerini belirlemek ve öğrendiklerini kendin için değerlendirmek işine yarayabilir."
  }
};


const dominantFeedback =
  STUDENT_FEEDBACK_MAP[top1.subject];

const top3Labels = top3.map(item =>
  item.subject
    .replace(" Zeka", "")
    .replace(" Zekası", "")
);

const studentFeedback = {
  eyebrow: "ÖĞRENME VE GÜÇ ALANLARIN",

  title: "Kendinle İlgili Yeni Bir Keşif",

  headline:
    dominantFeedback?.headline ||
    "Öğrenme Profilinde Bir Alan Öne Çıkıyor",

  highlights: top3Labels,

  message:
    dominantFeedback?.message ||
    "Yanıtların, bazı öğrenme ve kendini ifade etme yollarının sana diğerlerinden daha yakın olabileceğini gösteriyor.",

  counselorNote:
    "Bu envanter bir IQ testi değildir ve zekânı tek bir alana indirgemez. Sonuçlar, öğrenirken ve kendini ifade ederken sana daha yakın gelebilecek yollar hakkında ipuçları verir. Daha düşük görünen bir alan yetersizlik anlamına gelmez.",

  btnText: "Sonucumu Gördüm"
};

    // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Çoklu Zeka bir "Risk" testi değil, "Profil" testidir.
  // Bu yüzden masterRisk 'none' olarak işaretlenir ki radar ekranında gereksiz kalabalık yapmasın.
  
  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: developmentScore, // 0-100 arası gelişim yüzdesi
    masterRisk: "none",          // Radar ekranında uyarı vermemesi için
    isCritical: false, 
    domain: "profile",           // Bu bir profil/yetenek testi

    // 2. Mevcut Detaylı Veriler (Dashboard ve PDF için)
    summary: `Öne Çıkan Alan: ${top1.subject}`,
    riskLevel, 
    analysis: analysisText,
    chartData: chartData,
    topIntelligences: [top1, top2],
    details: details,
colorCode: "indigo",

// 🌟 Öğrenci test sonrası kişisel geri bildirimi
studentFeedback: studentFeedback,

recommendations:
  `${top1.subject} alanında öne çıkan eğilimin; proje tabanlı çalışmalar, farklılaştırılmış öğrenme etkinlikleri ve öğrencinin aktif katılımını sağlayan materyallerle desteklenmesi önerilir.`
  };
};